/**
 * Get currency symbol for a given currency code
 * This is a simplified version that doesn't depend on codegen types
 */
export const getCurrencySymbol = (currency) => {
    const upperCurrency = currency.toUpperCase();
    switch (upperCurrency) {
        case 'GBP':
            return '£';
        case 'USD':
            return '$';
        case 'EUR':
            return '€';
        default:
            return currency;
    }
};
